'use client';

import React from 'react';
import Image from 'next/image';
import styles from './AuthLayout.module.css';
import backgroundImage from '../../assets/auth/public-background.png';
import claimText from '../../assets/auth/text-claim.svg';
import { AuthenticationHeader } from '../AuthenticationHeader/AuthenticationHeader';
import { SocialMediaFooter } from '../SocialMediaFooter/SocialMediaFooter';

export type AuthLayoutProps = Readonly<{
  children: React.ReactNode;
}>;

export function AuthLayout({ children }: AuthLayoutProps) {
  return (
    <div className="min-h-dvh md:min-h-screen relative">
      <div className="fixed w-full h-screen bg-black" aria-hidden="true" />
      <Image
        className="fixed h-screen w-auto object-cover object-right right-0 top-0"
        src={backgroundImage}
        alt=""
        priority
        aria-hidden="true"
      />

      <div className={`fixed bottom-0 left-0 bg-secondary ${styles.formContainer} ${styles.wFormContainer} z-10`} aria-hidden="true" />

      <aside className={styles.textClaim} aria-label="Vision statement">
        <Image src={claimText} alt="To be the most dynamic global B2B events and communities business." fill priority />
      </aside>

      <div className="h-full w-full absolute z-20 flex items-center md:justify-start justify-center">
        <div className={`${styles.wFormContainer} h-full grid items-center justify-center mx-4 md:mx-0`}>
          <div className="grid justify-items-center items-start gap-16">
            <AuthenticationHeader />
            {children}
            <SocialMediaFooter />
          </div>
        </div>
      </div>
    </div>
  );
}

